import {Component, Input} from "@angular/core";


@Component({
    selector: "wbo-bi-items-container",
    templateUrl: "./items-container.component.html",
    styleUrls: ["./items-container.component.scss"]

})
export class ItemsContainerComponent {

    @Input() title: string;

}
